import * as Yup from "yup"

export const FIELDS_NAME = {
   COLORS: "colors",
}

export const initialValues = {
   [FIELDS_NAME.COLORS]: [],
}
export const validationSchema = Yup.object().shape({
   [FIELDS_NAME.COLORS]: Yup.array()
      .min(1, "Please select at least one color")
      .of(
         Yup.object().shape({
            label: Yup.string().required(),
            value: Yup.string().required(),
         })
      ),
})
